import { FocusMonitor } from '@angular/cdk/a11y';
import { AfterViewInit, Directive, ElementRef, Input, OnDestroy, inject } from '@angular/core';
import { fromEvent, Subject, filter, takeUntil } from 'rxjs';

/**
 * ! Accessibility
 * * Add A11y support to Swiper package
 * * Enable to add focus indicator
 * * Set the selected bullet with aria-current attribute
 */
@Directive({
    selector: 'swiper',
    standalone: true
})
export class AriaSwiperDirective implements AfterViewInit, OnDestroy {
  private focusMonitor = inject(FocusMonitor);
  private el = inject<ElementRef<HTMLElement>>(ElementRef);

  private destroy = new Subject<boolean>();

  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set isDataChanged(init: number) {
    if (init) {
      this.initBullets();
    }
  }

  ngAfterViewInit(): void {
    this.initBullets();
  }

  private initBullets() {
    setTimeout(() => {
      const swiperBulletsWrapper = this.el.nativeElement.querySelector('.swiper-pagination-bullets');
      if (!swiperBulletsWrapper) {
        return;
      }
      const swiperBullets = Array.from(swiperBulletsWrapper?.children);

      if (swiperBullets?.length) {
        const setCurrent = (el: HTMLElement, isActive) => el?.setAttribute('aria-current', isActive);

        let prevBullet = swiperBullets[0] as HTMLElement;
        setCurrent(prevBullet, 'true');

        fromEvent(swiperBulletsWrapper, 'click')
          .pipe(
            filter(event => (<HTMLElement>(event.target))?.classList.contains('swiper-pagination-bullet')),
            takeUntil(this.destroy)
          )
          .subscribe(event => {
            const target = event.target as HTMLElement;
            setCurrent(prevBullet, 'false');
            setCurrent(target, 'true');
            prevBullet = target;
          });

        // monitor bullets to add keyboard focus indicator
        swiperBullets.forEach((bullet: HTMLElement) => {
          this.focusMonitor.monitor(bullet)
            .pipe(takeUntil(this.destroy))
            .subscribe();
        });

      }
    }, 3000);
  }

  ngOnDestroy(): void {
    this.destroy.next(true);
    this.destroy.complete();
  }
}
